import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-white text-2xl font-bold mb-4" style={{ color: '#1c3855' }}>
              WallArt Pro
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Professional B2B wall art manufacturing with Canon Colorado technology. 
              Serving partners worldwide with premium quality and fast fulfillment.
            </p>
            <div className="flex gap-4">
              {['facebook', 'instagram', 'linkedin'].map((social) => (
                <a
                  key={social}
                  href={`#${social}`}
                  className="w-10 h-10 rounded-lg bg-gray-800 hover:bg-[#1c3855] flex items-center justify-center transition-colors"
                  aria-label={social}
                >
                  <span className="text-sm capitalize">{social[0]}</span>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">
              {t.footer.company}
            </h4>
            <ul className="space-y-3">
              {[
                { label: t.footer.about, href: '#about' },
                { label: t.footer.capabilities, href: '#capabilities' },
                { label: t.footer.technology, href: '#technology' },
                { label: t.footer.contact, href: '#contact' }
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="hover:text-[#1c3855] transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">
              {t.footer.support}
            </h4>
            <ul className="space-y-3">
              {[
                { label: t.footer.faq, href: '#faq' },
                { label: t.footer.shipping, href: '#shipping' },
                { label: t.footer.terms, href: '#terms' },
                { label: t.footer.privacy, href: '#privacy' }
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="hover:text-[#1c3855] transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">
              {t.footer.contact}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#1c3855] flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:info@wallartpro.com"
                  className="hover:text-[#1c3855] transition-colors"
                >
                  info@wallartpro.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-[#1c3855] flex-shrink-0 mt-0.5" />
                <a
                  href="tel:+1234567890"
                  className="hover:text-[#1c3855] transition-colors"
                >
                  +1 (234) 567-890
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#1c3855] flex-shrink-0 mt-0.5" />
                <span>
                  Manufacturing Facility<br />
                  USA & Canada
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} WallArt Pro. {t.footer.rights}
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#terms" className="hover:text-[#1c3855] transition-colors">
                {t.footer.terms}
              </a>
              <a href="#privacy" className="hover:text-[#1c3855] transition-colors">
                {t.footer.privacy}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
